/**
 * Componente para actualizar dinámicamente botones y mensajes de productos según rangos
 */

if ( typeof RangoProduct !== 'function' ) {

	class RangoProduct {
		
		constructor() {
			this.init();
		}

		init() {
			document.addEventListener('cart-updated', () => {
				this.updateAllProducts();
			});
			
			document.addEventListener('add-to-cart', async () => {
				if (typeof window.RangosSystem !== 'undefined') {
					await new Promise(resolve => setTimeout(resolve, 800));
					if (!window.RangosSystem.cart) {
						await window.RangosSystem.loadCart();
					} else {
						await new Promise(resolve => setTimeout(resolve, 200));
					}
					await this.updateAllProducts();
				} else {
					setTimeout(() => this.updateAllProducts(), 800);
				}
			});
			
			// Observar cuando se añaden nuevos product-form al DOM (para quick view modal)
			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					mutation.addedNodes.forEach((node) => {
						if (node.nodeType === 1) {
							// Verificar si el nodo es un product-form o contiene product-form
							if (node.tagName === 'PRODUCT-FORM') {
								setTimeout(() => this.updateProductForm(node), 300);
							} else if (node.querySelectorAll) {
								const productForms = node.querySelectorAll('product-form');
								if (productForms.length > 0) {
									setTimeout(() => {
										productForms.forEach(form => this.updateProductForm(form));
									}, 300);
								}
							}
							
							// Verificar si se añadió un modal-box (quick view)
							if (node.tagName === 'MODAL-BOX' || node.querySelector?.('modal-box')) {
								setTimeout(() => {
									const modalForms = node.querySelectorAll ? node.querySelectorAll('product-form') : [];
									if (modalForms.length > 0) {
										modalForms.forEach(form => this.updateProductForm(form));
									}
								}, 400);
							}
						}
					});
				});
			});
			
			observer.observe(document.body, {
				childList: true,
				subtree: true
			});
			
			// También escuchar cuando un modal-box se activa (clase 'active')
			const modalObserver = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
						const target = mutation.target;
						if (target.tagName === 'MODAL-BOX' && target.classList.contains('active')) {
							setTimeout(() => {
								const modalForms = target.querySelectorAll('product-form');
								modalForms.forEach(form => this.updateProductForm(form));
							}, 200);
						}
					}
				});
			});
			
			// Observar todos los modal-box existentes y futuros
			document.querySelectorAll('modal-box').forEach(modal => {
				modalObserver.observe(modal, {
					attributes: true,
					attributeFilter: ['class']
				});
			});
			
			// También observar cuando se añaden nuevos modal-box
			const modalBoxObserver = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					mutation.addedNodes.forEach((node) => {
						if (node.nodeType === 1 && node.tagName === 'MODAL-BOX') {
							modalObserver.observe(node, {
								attributes: true,
								attributeFilter: ['class']
							});
						}
					});
				});
			});
			
			modalBoxObserver.observe(document.body, {
				childList: true,
				subtree: true
			});
			
			setTimeout(() => this.updateAllProducts(), 1000);
		}

		async updateAllProducts() {
			if (typeof window.RangosSystem === 'undefined') {
				return;
			}
			
			if (!window.RangosSystem.cart) {
				await window.RangosSystem.loadCart();
			}
			
			document.querySelectorAll('product-form').forEach(async (form) => {
				await this.updateProductForm(form);
			});
		}

		async updateProductForm(form) {
			const rango = form.dataset.productRango ? parseInt(form.dataset.productRango) : null;
			
			if (!rango || rango === 1) {
				return;
			}
			
			const productData = {
				id: form.dataset.productId ? parseInt(form.dataset.productId) : null,
				metafields: {
					woo_attribute: {
						Rango: rango.toString()
					}
				}
			};
			
			const validacion = window.RangosSystem.puedeAñadir(productData);
			const submitButton = form.querySelector('[type="submit"]');
			
			if (!submitButton) return;
			
			if (!validacion.puede) {
				submitButton.disabled = true;
				submitButton.setAttribute('aria-disabled', 'true');
				submitButton.classList.add('rango-tooltip');
				submitButton.setAttribute('data-tooltip', validacion.mensaje);
				submitButton.setAttribute('title', validacion.mensaje);
			} else {
				if (!submitButton.hasAttribute('data-js-product-add-to-cart-disabled')) {
					submitButton.disabled = false;
					submitButton.removeAttribute('aria-disabled');
				}
				submitButton.classList.remove('rango-tooltip');
				submitButton.removeAttribute('data-tooltip');
				submitButton.removeAttribute('title');
			}
		}
	}

	// Inicializar cuando el DOM esté listo
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => {
			new RangoProduct();
		});
	} else {
		new RangoProduct();
	}

}

